export default {
  name: 'Nombre',
  role: 'Rol',
  kreaRole: 'Rol Krea',
  level: 'Nivel',
  levelPlaceholder: 'Selecciona los niveles',
  status: 'Estado',
  actions: 'Acciones',
  selectedUsers: {
    amount: '{selectedUsers} integrantes seleccionados',
    delete: 'Eliminar',
    sendInvitations: 'Reenviar invitaciones'
  },
  userActions: {
    delete: 'Eliminar',
    edit: 'Editar',
    save: 'Guardar',
    cancel: 'Cancelar',
    sendInvitation: 'Reenviar invitación'
  },
  emptyKreaRole: 'Ninguno'
}

export const en = {
  name: 'Name',
  role: 'Role',
  kreaRole: 'Krea role',
  level: 'Level',
  levelPlaceholder: 'Select levels',
  status: 'Status',
  actions: 'Actions',
  selectedUsers: {
    amount: '{selectedUsers} members selected',
    delete: 'Delete',
    sendInvitations: 'Resend invitations'
  },
  userActions: {
    delete: 'Delete',
    edit: 'Edit',
    save: 'Save',
    cancel: 'Cancel',
    sendInvitation: 'Resend invitation'
  },
  emptyKreaRole: 'None'
}

export const ca = {
  name: 'Nom',
  role: 'Rol',
  kreaRole: 'Rol Krea',
  level: 'Nivell',
  levelPlaceholder: 'Seleccioni els nivells',
  status: 'Estat',
  actions: 'Accions',
  selectedUsers: {
    amount: '{selectedUsers} integrants seleccionats',
    delete: 'Eliminar',
    sendInvitations: 'Reenviar invitacions'
  },
  userActions: {
    delete: 'Eliminar',
    edit: 'Editar',
    save: 'Desa',
    cancel: 'Cancelar',
    sendInvitation: 'Tornar a enviar invitació'
  },
  emptyKreaRole: 'Cap'
}
